/* XLサイズ特集（sections/main-feature-xl.liquid）専用：動画の再生と、形での絞り込み */
(function(){
  var root = document.querySelector('.xlf'); if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var narrow = window.matchMedia('(max-width: 899px)');

  function tryPlay(v){ if (!v || reduce) return; var p = v.play(); if (p && p.catch) p.catch(function(){}); }
  /* 軽い720pを使う（無ければ元のURLに戻す）。ストアのLiquidは1080pのURLしか返さないため */
  function lite(u){ return u ? u.replace('.HD-1080p-7.2Mbps-', '.HD-720p-4.5Mbps-') : u; }
  function setSrc(v, u, light){
    var s2 = light ? lite(u) : u;
    if (s2 !== u){ v.addEventListener('error', function(){ if (v.getAttribute('src') !== u){ v.src = u; tryPlay(v); } }, { once:true }); }
    v.src = s2;
  }

  /* スマホはヘッダーが画面に固定で重なるため、その高さぶんメインビジュアルを下げる（ボタン・文字が隠れないように） */
  var heroBox = root.querySelector('.xlf-hero');
  function fitTop(){
    if (!heroBox) return;
    var t = 0;
    ['.wh-bar', 'header.wh'].forEach(function(sel){
      var el = document.querySelector(sel);
      if (el && getComputedStyle(el).position === 'fixed' && el.offsetHeight) t += el.offsetHeight;
    });
    heroBox.style.marginTop = t ? t + 'px' : '';
  }
  fitTop();
  addEventListener('resize', fitTop);
  addEventListener('load', fitTop);

  /* メインビジュアル：画面幅で PC 用／スマホ用の動画を選ぶ */
  var hm = root.querySelector('[data-xlf-hero]'), hv = hm && hm.querySelector('video'), pp = root.querySelector('[data-xlf-pp]');
  if (hv){
    var src = (narrow.matches ? hm.getAttribute('data-sp') : hm.getAttribute('data-pc')) || hm.getAttribute('data-pc') || hm.getAttribute('data-sp');
    if (src){ setSrc(hv, src, narrow.matches); hv.preload = 'auto'; }
    if (reduce){ if (pp) pp.setAttribute('aria-pressed', 'true'); }
    else { hv.autoplay = true; tryPlay(hv); }
    if (pp){
      var sync = function(){ var paused = hv.paused; pp.setAttribute('aria-pressed', paused ? 'true' : 'false'); pp.setAttribute('aria-label', paused ? '動画を再生' : '動画を一時停止'); };
      hv.addEventListener('play', sync); hv.addEventListener('pause', sync); setTimeout(sync, 1500);
      pp.addEventListener('click', function(){
        if (hv.paused){ var r = hv.play(); if (r && r.catch) r.catch(function(){}); }
        else { hv.pause(); }
      });
    }
  }

  /* 下の動画：見えたら読み込んで再生、外れたら止める */
  var vids = [].slice.call(root.querySelectorAll('video[data-xlf-vid]'));
  function load(v){ if (!v.getAttribute('src') && v.getAttribute('data-xlf-vid')){ setSrc(v, v.getAttribute('data-xlf-vid'), narrow.matches || v.classList.contains('xlf-mv__video')); } }
  if ('IntersectionObserver' in window){
    var vio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v = e.target;
        if (e.isIntersecting){ load(v); tryPlay(v); }
        else if (!v.paused){ v.pause(); }
      });
    }, { rootMargin:'120px 0px', threshold:0.35 });
    vids.forEach(function(v){ vio.observe(v); });
  } else {
    vids.forEach(function(v){ load(v); v.controls = true; });
  }
  if (reduce){ vids.forEach(function(v){ v.controls = true; }); }

  /* 形で絞り込む ＋ もっと見る */
  var grid = root.querySelector('[data-xlf-grid]'); if (!grid) return;
  var items = [].slice.call(grid.querySelectorAll('[data-xlf-item]'));
  var tabs = [].slice.call(root.querySelectorAll('[data-xlf-tab]'));
  var more = root.querySelector('[data-xlf-more]'), rest = root.querySelector('[data-xlf-rest]');
  var step = parseInt(grid.getAttribute('data-step'), 10) || 12;
  var cur = '', shown = step;

  function tagsOf(t){ return t ? t.split(',').map(function(s){ return s.trim(); }).filter(Boolean) : []; }
  /* data-shape は空白区切りで複数（特集LPのカード）。どれか1つでも絞り込みに当たれば表示 */
  function match(el, list){
    if (!list.length) return true;
    var sh = (el.getAttribute('data-shape') || '').split(/\s+/);
    for (var i = 0; i < sh.length; i++){ if (sh[i] && list.indexOf(sh[i]) > -1) return true; }
    return false;
  }

  tabs.forEach(function(b){
    var list = tagsOf(b.getAttribute('data-xlf-tab')), n = 0;
    items.forEach(function(el){ if (match(el, list)) n++; });
    var c = b.querySelector('[data-xlf-cnt]'); if (c) c.textContent = n;
    if (!n && list.length) b.hidden = true;
  });

  function render(anim){
    var list = tagsOf(cur), k = 0, total = 0;
    items.forEach(function(el){
      var ok = match(el, list);
      if (ok) total++;
      var vis = ok && k < shown;
      if (ok) k++;
      el.hidden = !vis;
      el.classList.remove('is-show');
      if (vis){
        el.classList.add('is-in');
        if (anim){ void el.offsetWidth; el.classList.add('is-show'); }
      }
    });
    var left = total - Math.min(total, shown);
    if (more){ more.hidden = left <= 0; if (rest) rest.textContent = '（あと' + left + '型）'; }
  }

  tabs.forEach(function(b){
    b.addEventListener('click', function(){
      cur = b.getAttribute('data-xlf-tab') || ''; shown = step;
      tabs.forEach(function(x){ var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      render(true);
      var top = grid.getBoundingClientRect().top;
      if (top < 0 || top > innerHeight * .6){ window.scrollTo({ top: scrollY + top - 140, behavior: reduce ? 'auto' : 'smooth' }); }
    });
  });
  if (more){ more.addEventListener('click', function(){ shown += step; render(true); }); }
  render(false);
})();
